import { FontIcon, Label, Stack, Toggle, TooltipHost } from '@fluentui/react';
import { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { nameof } from '../../utils/stringUtils';
import { InlineDiv } from '../../shared/styled-components';

const Container = styled.div`
  margin-bottom: 0.5rem;
`;

interface IProps {
  label: string;
  tooltip?: string;
  enabled: boolean;
  onEnabledChange(value: boolean): void;
  children: ReactNode;
}

const ThresholdField: FC<IProps> = ({ label, tooltip, enabled, onEnabledChange, children }) => (
  <Container>
    <Stack horizontal horizontalAlign="space-between" verticalAlign="center" tokens={{ childrenGap: '0.5rem' }}>
      <InlineDiv>
        <Label>{label}</Label>
        {
          tooltip &&
          <TooltipHost content={tooltip} styles={{ root: { display: 'flex', marginLeft: '0.5rem', cursor: 'help !important' } }}>
            <FontIcon iconName="Info" />
          </TooltipHost>
        }
      </InlineDiv>
      <Toggle
        checked={enabled}
        onChange={(_, checked) => onEnabledChange(checked ?? false)}
      />
    </Stack>
    {children}
  </Container>
);

ThresholdField.displayName = nameof({ ThresholdField });
export default ThresholdField;